import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const deleteDocumentRequirementOperation = async (
  id: number,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    await appApi.deleteUserRoleDocumentRequirement(id);

    // Refresh the global settings to show the updated list
    await globalSettingsStores.fetchSetting();
  } catch (error) {
    console.error('Error deleting document requirement:', error);
    // You might want to show an error message to the user here
  } finally {
    setLoading(false);
  }
};
